<div *ngIf="loading" class="flex justify-center p-5">
  <p-progressSpinner></p-progressSpinner>
</div>
<div
  *ngIf="error"
  class="p-4 bg-red-100 border border-red-300 rounded text-red-700"
>
  <i class="pi pi-exclamation-triangle mr-2"></i>{{ error }}
</div>
<div *ngIf="!loading && !error">
  <app-intervention-reschedule-steps
    [interventionId]="interventionId"
    [erpSource]="erpSource"
  >
  </app-intervention-reschedule-steps>
</div>
